export default "__VITE_ASSET__GBdBB0H4__"